<template>
  <div class="content-page">
    <div class="bd">
      <div class="content">
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="配送时段：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <div class="delivery-time">
                    <div
                      class="item"
                      v-for="(item, index) in shopForm.deliveryTimeList"
                      :key="index"
                    >
                      <el-time-picker
                        is-range
                        v-model="item.timeRange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围"
                        value-format="HH:mm"
                        format="HH:mm"
                        @change="timeChange"
                      >
                      </el-time-picker>
                      <el-button
                        class="button-del"
                        type="danger"
                        size="medium"
                        @click="delDeliveryTimeList(index)"
                      >
                        删除</el-button
                      >
                    </div>
                    <el-button
                      class="button-add"
                      size="medium"
                      @click="addDeliveryTimeList()"
                      >+ 添加</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="店铺标签：">
              <div class="form-inline-content">
                <div class="inside-content">
                  <div class="form-content">
                    <div class="indefinite-width">
                      <el-tag
                        :key="tagindex"
                        v-for="(tag, tagindex) in shopForm.shopTags.value"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)"
                        >{{ tag }}</el-tag
                      >
                      <el-input
                        class="input-new-tag"
                        v-if="shopForm.shopTags.attrValueInputVisible"
                        v-model="shopForm.shopTags.attrValueInputValue"
                        :ref="`saveTagInput`"
                        size="small"
                        @keyup.enter.native="handleAttrValueInputConfirm()"
                        @blur="handleAttrValueInputConfirm()"
                      ></el-input>
                      <el-button
                        v-else
                        class="button-new-tag"
                        size="small"
                        @click="showAttrValueInput()"
                        >+ 添加</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="submit-btn-container">
              <el-button type="primary" @click="submitForm('shopForm')"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShopInfo, modifyShopInfo } from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { mapActions } from "vuex";
export default {
  mixins: [commonFuc],
  data() {
    return {
      shopInfoForm: null,
      shopForm: {
        shopTags: {
          name: "",
          value: [],
          specValueList: [],
          attrValueInputVisible: false,
          attrValueInputValue: "",
        },
        deliveryTimeList: [
          {
            timeRange: ["00:00", "23:00"],
          },
        ],
      },
    };
  },
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  watch: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["updateShopInfo"]),
    getPageData() {
      this.getShopInfo();
    },
    handleClose(tag) {
      this.shopForm.shopTags.value.splice(
        this.shopForm.shopTags.value.indexOf(tag),
        1
      );
    },
    handleAttrValueInputConfirm() {
      let attrValueInputValue = this.shopForm.shopTags.attrValueInputValue;
      if (attrValueInputValue) {
        this.shopForm.shopTags.value.push(attrValueInputValue);
      }
      this.shopForm.shopTags.attrValueInputVisible = false;
      this.shopForm.shopTags.attrValueInputValue = "";
    },
    getShopInfo() {
      getShopInfo().then((shopInfo) => {
        if (shopInfo.code == 1) {
          this.shopInfoForm = shopInfo.data;
          if (shopInfo.data.shopTags && shopInfo.data.shopTags.length) {
            this.shopForm.shopTags.value = [];
            shopInfo.data.shopTags = JSON.parse(shopInfo.data.shopTags);
            shopInfo.data.shopTags.forEach((val) => {
              this.shopForm.shopTags.value.push(val.tagName);
            });
          }
          if (
            shopInfo.data.deliveryTimeList &&
            shopInfo.data.deliveryTimeList.length
          ) {
            this.shopForm.deliveryTimeList = [];
            shopInfo.data.deliveryTimeList = JSON.parse(
              shopInfo.data.deliveryTimeList
            );
            shopInfo.data.deliveryTimeList.forEach((val) => {
              this.shopForm.deliveryTimeList.push({
                timeRange: [
                  val.timeRange.split("-")[0],
                  val.timeRange.split("-")[1],
                ],
              });
            });
          }
        }
      });
    },
    timeChange(date) {
      console.log(date);
      if (date[0] > date[1]) {
        this.$notify({
          title: "提示",
          message: "配送开始时间不能大于结束时间",
          type: "error",
          duration: 2000,
        });
        this.date = [];
      }
    },
    submitForm(formName, cb) {
      if (this.shopForm.shopTags.value.length) {
        this.shopInfoForm.shopTags = [];
        this.shopForm.shopTags.value.forEach((val) => {
          this.shopInfoForm.shopTags.push({
            tagName: val,
          });
        });
        this.shopInfoForm.shopTags = JSON.stringify(this.shopInfoForm.shopTags);
      } else {
        this.shopInfoForm.shopTags = [];
        // this.$notify({
        //   title: '提示',
        //   message: '店铺标签不能为空',
        //   type: 'error',
        //   duration: 2000
        // })
      }
      if (this.shopForm.deliveryTimeList.length) {
        let isReturn = false;
        this.shopInfoForm.deliveryTimeList = [];
        let setList = [];
        this.shopForm.deliveryTimeList.forEach((val, index) => {
          if (isReturn) return;
          if (!val.timeRange) {
            this.$notify({
              title: "提示",
              message: "请填写配送时间",
              type: "error",
              duration: 2000,
            });
            isReturn = true;
            return;
          }
          if (val.timeRange[0] == val.timeRange[1]) {
            console.log(val);
            this.$notify({
              title: "提示",
              message: "配送开始时间和结束时间不能相同",
              type: "error",
              duration: 2000,
            });
            isReturn = true;
            return;
          }
          if (val.timeRange[0] > val.timeRange[1]) {
            console.log(val);
            this.$notify({
              title: "提示",
              message: "配送开始时间不能大于结束时间",
              type: "error",
              duration: 2000,
            });
            isReturn = true;
            return;
          }
          setList.push(
            JSON.stringify({
              timeRange: `${val.timeRange[0]}-${val.timeRange[1]}`,
            })
          );
          if (index == this.shopForm.deliveryTimeList.length - 1) {
            console.log(setList.length, Array.from(new Set(setList)).length);
            if (setList.length != Array.from(new Set(setList)).length) {
              this.$notify({
                title: "提示",
                message: "不允许存在相同配送时间配置",
                type: "error",
                duration: 2000,
              });
            }
            new Set(setList).forEach((val) => {
              this.shopInfoForm.deliveryTimeList.push(JSON.parse(val));
            });
          }
        });
        this.shopInfoForm.deliveryTimeList = JSON.stringify(
          this.shopInfoForm.deliveryTimeList
        );
        if (isReturn) {
          return;
        }
      } else {
        this.$notify({
          title: "提示",
          message: "请配置配送时段",
          type: "error",
          duration: 2000,
        });
        return;
      }
      modifyShopInfo(this.shopInfoForm).then((res) => {
        if (res.code == 1) {
          getShopInfo().then((shopInfo) => {
            this.updateShopInfo(shopInfo.data);
            if (cb) {
              cb(shopInfo.data);
              return;
            }
            this.$notify({
              title: "提示",
              message: "保存成功",
              type: "success",
              duration: 2000,
            });
            this.getShopInfo();
          });
        } else {
          if (res.code == 11) {
            this.$notify({
              title: "提示",
              message: "如需在线支付，请申请网付认证",
              type: "warning",
              duration: 2000,
            });
            return;
          }
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },

    showAttrValueInput() {
      this.shopForm.shopTags.attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput`].focus();
      });
    },

    addShopTag() {
      this.shopForm.shopTags.push({
        name: "",
        value: [],
        specValueList: [],
        attrValueInputVisible: false,
        attrValueInputValue: "",
      });
    },
    addDeliveryTimeList() {
      this.shopForm.deliveryTimeList.push({
        timeRange: ["00:00", "23:00"],
      });
    },
    delDeliveryTimeList(index) {
      this.shopForm.deliveryTimeList.splice(index, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .bd {
    height: 100%;
    padding: 20px;
    .content-container {
      padding-top: 20px;
      .delivery-time {
        .item {
          margin-bottom: 8px;
          .button-del {
            margin-left: 10px;
            display: none;
          }
          &:hover {
            .button-del {
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>
